import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mkp-read-only-banner',
  templateUrl: './read-only-banner.component.html',
  styleUrl: './read-only-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class ReadOnlyBannerComponent {}
